<template>
  <div
    class="approval"
    :class="{'active': scope.row.status !== 1 && scope.row.noneApproveCount > 0}"
    @click="goToDetail(scope.row.status !== 1 && scope.row.noneApproveCount > 0)"
  >
    {{ scope.row.noneApproveCount }}
  </div>
</template>
<script>
export default {
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    async goToDetail (status) {
      if (status) {
        const { success, data } = await MBASVCAPIS.MissionApi.missionCourseExamListGet({
          _id: this.scope.row._id
        })
        if (success) {
          let examId = ''
          let len = data.data.length
          for (let i = 0; i < len; i++) {
            if (data.data[i].type === 2) {
              examId = data.data[i]._id
              break
            }
          }
          // data.data.forEach(item => {
          //   if (item.type === 2) {
          //     examId = item._id
          //   }
          // })
          this.$router.push({
            path: '/business-school/examination-manage/task-exam-statistics',
            query: {
              taskId: this.scope.row._id,
              examId: examId
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .approval.active {
    color: #009cff;
    cursor: pointer;
  }
</style>
